import { render, staticRenderFns } from "./bar-group-chart.vue?vue&type=template&id=2720ca30"
import script from "./bar-group-chart.vue?vue&type=script&lang=js"
export * from "./bar-group-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports